// extracted by mini-css-extract-plugin
export var active = "partnerSectionDesktop-module--active--c93ec";
export var image = "partnerSectionDesktop-module--image--3c9b4";
export var pagination = "partnerSectionDesktop-module--pagination--0cc00";
export var slider = "partnerSectionDesktop-module--slider--5327f";
export var sliderPicture = "partnerSectionDesktop-module--sliderPicture--6be7e";
export var wrapper = "partnerSectionDesktop-module--wrapper--2323e";